import axios from 'axios';

/* Shared AI-job poller (SEO text + image gen). Backoff polling, network-blip
 * retries, elapsed reporting, cooperative cancel. Resolves with the final
 * job payload ({status:'done', ...}) or throws Error (e.cancelled on abort). */

const sleep = ms => new Promise(res => setTimeout(res, ms));

export async function pollAiJob(jobId, { onPhase, isCancelled, maxMs = 5 * 60 * 1000 } = {}) {
  const t0 = Date.now();
  let wait = 4000;
  for (;;) {
    if (isCancelled && isCancelled()) {
      const e = new Error('لغو شد.');
      e.cancelled = true;
      throw e;
    }
    if (Date.now() - t0 >= maxMs) throw new Error('زمان طولانی شد؛ بعداً دوباره تلاش کن.');
    await sleep(wait);
    if (isCancelled && isCancelled()) {
      const e = new Error('لغو شد.');
      e.cancelled = true;
      throw e;
    }
    let s;
    try {
      s = (await axios.get('/admin/ai/job-status', { params: { job_id: jobId } })).data;
    } catch (e) {
      if (e.response?.status === 422) throw new Error(e.response.data?.message || 'خطا در تولید.');
      // قطعی لحظه‌ای اینترنت: عقب‌نشینی و تلاش مجدد
      wait = Math.min(wait + 2000, 15000);
      onPhase && onPhase('retry', Date.now() - t0);
      continue;
    }
    if (s.status === 'done') return s;
    if (s.status === 'error') throw new Error(s.message || 'خطا در تولید.');
    onPhase && onPhase(s.status, Date.now() - t0);
    wait = Math.min(wait + 1500, 15000);
  }
}

export const fmtElapsed = ms => {
  const s = Math.floor(ms / 1000);
  if (s < 60) return `${s} ثانیه`;
  return `${Math.floor(s / 60)} دقیقه و ${s % 60} ثانیه`;
};
